.access-image{height:70vh;background-image:url("./media/no_access-PRRH7FAP.png");background-repeat:no-repeat;background-position:center;background-size:60vh}
/*# sourceMappingURL=custom-error.component-V7H5JTS2.css.map */
